export default __webpack_public_path__ + "static/media/m-jobshub-05-v1.71bba422.jpg";